import * as fn from '../functions';
import cloneDeep from 'lodash/cloneDeep';

export function setAppState(instance, data, onStore) {
  fn.eachObject(
    (storeName, snapshot) => {
      const store = instance.stores[storeName];
      if (store) {
        const state = store.state;
        if (fn.isMutableObject(state)) {
          Object.assign(store.state, cloneDeep(snapshot));
        } else {
          store.state = snapshot;
        }
        onStore(store, store.state);
      }
    },
    [data]
  );
}

export function snapshot(instance, storeNames = []) {
  const stores = storeNames.length ? storeNames : Object.keys(instance.stores);
  return stores.reduce((obj, storeHandle) => {
    const storeName = storeHandle.displayName || storeHandle;
    const store = instance.stores[storeName];
    const {config} = store.StoreModel;
    store.lifecycle('snapshot');
    const customSnapshot = config.onSerialize && config.onSerialize(store.state);
    obj[storeName] = customSnapshot ? customSnapshot : store.getState();
    return obj;
  }, {});
}

export function saveInitialSnapshot(instance, key) {
  const state = cloneDeep(instance.stores[key].state);
  instance._initSnapshot[key] = state;
  instance._lastSnapshot[key] = state;
}

export function filterSnapshots(instance, state, stores) {
  return stores.reduce((obj, store) => {
    const storeName = store.displayName || store;
    if (!state[storeName]) {
      throw new ReferenceError(`${storeName} is not a valid store`);
    }
    obj[storeName] = state[storeName];
    return obj;
  }, {});
}
